import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import DeleteWebemaillinkEditing from './deletewebemaillinkediting';

export default class Deletewebemaillink  extends Plugin {
  static get pluginName() {
    return 'Deletewebemaillink';
  }

  static get requires() {
    return [ DeleteWebemaillinkEditing ];
  }
}
